"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentReferenceTypeGroupSchema = void 0;
exports.ContentReferenceTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/reference/type-groups/content.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ContentReferenceTypeGroup",
    "description": "ContentReferenceTypeGroup represents one of the following types: AppleImmersiveVideoReference, AudioClipReference, AudioEpisodeReference, AudioSeasonReference, AudioSeriesReference, AuthorProfileReference, ContentCollectionReference, EditorialListReference, EnergyDrinkReference, EpisodeVideoReference, EventDetailReference, EventProfileReference, EventSeasonReference, EventSeriesReference, ExternalPersonReference, ExternalTeamReference, ExternalContentReference, FilmReference, ImageGalleryReference, ImageReference, Immersive3DModelReference, JudgeReference, LiveVideoReference, LocationReference, MiscReference, OccasionCampaignReference, OccasionReference, OnsitePromotionReference, PartnerProfileReference, PersonProfileReference, PhotographerReference, PlaylistReference, PreviewClipReference, ProjectProfileReference, RallyDriverReference, RallyTeamReference, RecapVideoReference, ResultsAndStandingsReference, SeasonReference, ShowReference, StoryReference, TagReference, TeamProfileReference, TrailerVideoReference, TvCommercialReference, TvPartnerChannelReference, Video3DReference, VideoChannelReference, VideoReference, Video360Reference",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/apple-immersive-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/audio-clips.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/audio-episodes.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/audio-seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/audio-series.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/author-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/collections.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/editorial-lists.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/energy-drinks.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/episode-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/event-details.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/event-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/event-seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/event-series.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/external-persons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/external-teams.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/externals.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/films.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/image-galleries.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/images.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/immersive-3d-models.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/judges.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/live-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/locations.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/misc.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/occasion-campaigns.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/occasions.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/onsite-promotions.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/partner-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/person-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/photographers.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/playlists.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/preview-clips.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/project-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/rally-drivers.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/rally-teams.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/recap-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/results-standings.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/shows.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/stories.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/tags.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/team-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/trailer-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/tv-commercials.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/tv-partner-channels.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/video-3d.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/video-channels.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/reference/content/videos-360.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,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